import React from "react";
import { Route, Routes } from "react-router-dom";

import About from "./components/About";
import ForgotPassword from "./components/Users/ForgotPassword";
import Login from "./components/Auth/Login";
import NotFound from "./components/NotFound";
import Project from "./components/Project";
import Projects from "./components/Projects";
import Organization from "./components/Organization";
import Organizations from "./components/Organizations";
import AiModel from "./components/AiModel";
import AiModels from "./components/AiModels";
import User from "./components/User";
import Users from "./components/Users";
import Register from "./components/Users/Register";
import ResetPassword from "./components/Users/ResetPassword";
import UserProfile from "./components/Users/UserProfile";


const AppRoutes = () =>
  <Routes>
    <Route path="/" exact element={ <Projects/> } />
    <Route path="/about" exact element={ <About/> } />
    <Route path="/projects" exact element={ <Projects/> } />
    <Route path="/projects/:uuid" exact element={ <Project/> }/>
    <Route path="/organizations" exact element={ <Organizations/> } />
    <Route path="/organizations/:uuid" exact element={ <Organization/> }/>
    <Route path="/ai-models" exact element={ <AiModels/> }/>
    <Route path="/ai-models/:uuid" exact element={ <AiModel/> }/>
    <Route path="/users" exact element={ <Users/> }/>
    <Route path="/users/:uuid" exact element={ <User/> }/>

    <Route path="/login" exact element={ <Login/> } />
    <Route path="/forgot-password" exact element={ <ForgotPassword/> } />
    <Route path="/register" exact element={ <Register/> } />
    <Route path="/reset-password" exact element={ <ResetPassword/> } />
    <Route path="/user-profile" exact element={ <UserProfile/> } />
    <Route element={NotFound} />
  </Routes>;

export default AppRoutes;
